const TechBackground = () => {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0" aria-hidden="true">
      {/* Hexagon grid pattern */}
      <svg
        className="absolute inset-0 w-full h-full opacity-[0.15]"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern
            id="hexPattern"
            width="56"
            height="100"
            patternUnits="userSpaceOnUse"
            patternTransform="scale(2)"
          >
            <path
              d="M28 0 L56 16.67 L56 50 L28 66.67 L0 50 L0 16.67 Z"
              fill="none"
              stroke="hsl(200 60% 50%)"
              strokeWidth="0.5"
            />
            <path
              d="M28 66.67 L56 83.33 L56 100 M28 66.67 L0 83.33 L0 100"
              fill="none"
              stroke="hsl(200 60% 50%)"
              strokeWidth="0.5"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#hexPattern)" />
      </svg>

      {/* Scattered dots / nodes */}
      <svg
        className="absolute inset-0 w-full h-full opacity-[0.15]"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern
            id="dotsPattern"
            width="100"
            height="100"
            patternUnits="userSpaceOnUse"
          >
            <circle cx="10" cy="10" r="1.5" fill="hsl(200 80% 60%)" />
            <circle cx="50" cy="30" r="1" fill="hsl(200 80% 60%)" />
            <circle cx="80" cy="70" r="2" fill="hsl(200 80% 60%)" />
            <circle cx="30" cy="80" r="1" fill="hsl(200 80% 60%)" />
            <circle cx="70" cy="20" r="1.5" fill="hsl(200 80% 60%)" />
            <line x1="10" y1="10" x2="50" y2="30" stroke="hsl(200 80% 60%)" strokeWidth="0.3" />
            <line x1="50" y1="30" x2="70" y2="20" stroke="hsl(200 80% 60%)" strokeWidth="0.3" />
            <line x1="80" y1="70" x2="30" y2="80" stroke="hsl(200 80% 60%)" strokeWidth="0.3" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#dotsPattern)" />
      </svg>

      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-transparent to-background opacity-60" />
    </div>
  );
};

export default TechBackground;
